import { axiosMockAdapterInstance } from "apis";
import { getResponseData } from "mocksdata/index";

const regisData = [
  {
    currentStep: "WALLET_SETUP_COMPLETED",
    approvedStatus: "APPROVED",
    autoWithdrawal: "MANUAL",
    merchantType: 1,
    status: 3,
    localCurrency: "USD",
    emailPreferences: {
      "operation.charge_created": true,
      "operation.charge_expired": true,
      "operation.payment_status_updated": true,
      "operation.withdrawal_status_updated": true,
      "operation.invoice_created": true,
      "security.authentication_device_updated": true,
      "security.password_updated": true,
      "security.close_account": true,
      "security.remind_backup_codes_exceed_limit": true,
      "settings.support_email_updated": true,
      "settings.accept_crypto_list": true,
      "settings.flexible_payment_updated": true,
      "settings.auto_withdrawal_updated": true,
    },
    lastWithdrawal: [
      { "usdt-bsc": "2022-05-23T01:38:56.775Z" },
      { "usdc-bsc": "2022-05-23T01:38:56.775Z" },
      { "busd-bsc": "2022-05-23T01:38:56.775Z" },
      { "eth-bsc": "2022-05-23T01:38:56.775Z" },
      { "dai-bsc": "2022-05-23T01:38:56.775Z" },
      { "ada-bsc": "2022-05-23T01:38:56.775Z" },
      { "luna-bsc": "2022-05-23T01:38:56.775Z" },
      { "shib-bsc": "2022-05-23T01:38:56.775Z" },
      { "doge-bsc": "2022-05-23T01:38:56.775Z" },
      { "xrp-bsc": "2022-05-23T01:38:56.775Z" },
      { "bnb-bsc": "2022-05-23T01:38:56.775Z" },
    ],
    nextWithdrawal: [
      { "usdt-bsc": "2022-05-23T01:38:56.775Z" },
      { "usdc-bsc": "2022-05-23T01:38:56.775Z" },
      { "busd-bsc": "2022-05-23T01:38:56.775Z" },
      { "eth-bsc": "2022-05-23T01:38:56.775Z" },
      { "dai-bsc": "2022-05-23T01:38:56.775Z" },
      { "ada-bsc": "2022-05-23T01:38:56.775Z" },
      { "luna-bsc": "2022-05-23T01:38:56.775Z" },
      { "shib-bsc": "2022-05-23T01:38:56.775Z" },
      { "doge-bsc": "2022-05-23T01:38:56.775Z" },
      { "xrp-bsc": "2022-05-23T01:38:56.775Z" },
      { "bnb-bsc": "2022-05-23T01:38:56.775Z" },
    ],
    id: "628ae5b0041e74000817b93f",
    rejectReason: null,
    name: null,
    email: "minhbn@sotanext.com",
    supportEmail: "minhbn@sotanext.com",
    wallets: [
      {
        bip44Path: "m/44'/60'/0'/0",
        currency: "BNB",
        isMainnet: false,
        provider: "https://speedy-nodes-nyc.moralis.io/d520aab28a624b9824dd80d7/bsc/testnet",
        wssProvider: "wss://speedy-nodes-nyc.moralis.io/d520aab28a624b9824dd80d7/bsc/testnet/ws",
        network: "binance-smart-chain-testnet",
        fpMasterContract: "0x463Af0c60a4bFc8cDb5EA52b9CB4A1102D315B53",
        transactionUrl: "https://testnet.bscscan.com/tx/",
        fizenReceiverWalletAddr: "0x12c8fEbF99C65B53158644f910B565063e967B62",
        contract: "0xd9F75c47C0787FB422c034337e737849231C6938",
        address: "0x88EA8A947597608c00a889fA1DF7e1C7f41918f1",
      },
    ],
    cryptoCurrencySettings: [
      {
        name: "USDT",
        slug: "usdt-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x53653887c75d611A8EfbdA2c1FB97CFD17Bfff71",
        cmcId: 825,
        decimal: 18,
        type: ["STABLE_COIN", "POPULAR"],
        gasLimit: 70871,
        status: "INACTIVE",
        isEnabled: false,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        defaultStatus: "INACTIVE",
      },
      {
        name: "USDC",
        slug: "usdc-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x3a943EFa37979952DE37168aE7D9B2E8723D9316",
        cmcId: 3408,
        decimal: 18,
        type: ["STABLE_COIN", "POPULAR"],
        gasLimit: 70871,
        status: "INACTIVE",
        isEnabled: false,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        defaultStatus: "INACTIVE",
      },
      {
        name: "BUSD",
        slug: "busd-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x718f381412b0ec0B9a6f69a77E3c7128C75E77B5",
        cmcId: 4687,
        decimal: 18,
        type: ["STABLE_COIN", "POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        defaultStatus: "ACTIVE",
      },
      {
        name: "WETH",
        slug: "eth-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x17fA95F49e69F82766C7930D4035b2973fbe95b8",
        cmcId: 2396,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "INACTIVE",
        isEnabled: false,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        defaultStatus: "INACTIVE",
      },
      {
        name: "DAI",
        slug: "dai-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x460b248e24d2b14F59bf09a27fF73e4Bee7E140a",
        cmcId: 4943,
        decimal: 18,
        type: ["OTHERS"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        defaultStatus: "INACTIVE",
      },
      {
        name: "ADA",
        slug: "ada-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x78e67d427480D18890C807B3be219A8777900EcB",
        cmcId: 2010,
        decimal: 18,
        type: ["OTHERS"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        defaultStatus: "INACTIVE",
      },
      {
        name: "LUNA",
        slug: "luna-bsc",
        network: "binance-smart-chain-testnet",
        address: "0xc4E4FE5FcB38fE9D3BC327e384A57105955C9F9d",
        cmcId: 4172,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        defaultStatus: "INACTIVE",
      },
      {
        name: "SHIB",
        slug: "shib-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x00A7D83B69C8c9223438F0Aca93453c89e0E66Ac",
        cmcId: 5994,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        defaultStatus: "INACTIVE",
      },
      {
        name: "DOGE",
        slug: "doge-bsc",
        network: "binance-smart-chain-testnet",
        address: "0xD21399ad2bF05963D9a848697FdbF415c4D72923",
        cmcId: 74,
        decimal: 8,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        defaultStatus: "INACTIVE",
      },
      {
        name: "XRP",
        slug: "xrp-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x8802F1BA3748017B6a69A90bEd19c0542D0917bc",
        cmcId: 52,
        decimal: 18,
        type: ["OTHERS"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        defaultStatus: "INACTIVE",
      },
      {
        name: "BNB",
        slug: "bnb-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x0000000000000000000000000000000000000000",
        cmcId: 1839,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0.00173896520851342",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        defaultStatus: "INACTIVE",
        withdrawalHistory: "62907f535d6a600008416032",
      },
    ],
    provider: 1,
    fizenpayFeePerc: "33",
    createdAt: "2022-05-23T01:38:56.779Z",
    setUppedAt: "2022-05-23T01:40:26.717Z",
    requestCloseAccountAt: "2022-05-27T08:21:34.728Z",
    closedAccountAt: "2022-05-27T08:30:00.072Z",
    customServiceFee: {
      status: "INITIAL",
      serviceFee: "0",
      type: "DEFAULT",
      startTime: "2022-05-23T01:40:26.717Z",
      endTime: "2022-05-23T01:40:26.717Z",
    },
    updatedAt: "2022-05-26T02:24:30.875Z",
    flexiblePaymentSettings: {
      type: "ABSOLUTE",
      underPaymentThresholdValue: "0.1",
      underPaymentCurrency: "USD",
      overPaymentThresholdValue: "5",
      overPaymentCurrency: "USD",
    },
    security: { is2faEnabled: true, isEmailVerifyEnabled: false, emailCodeExp: 0 },
  },
  {
    currentStep: "WALLET_SETUP_COMPLETED",
    approvedStatus: "APPROVED",
    autoWithdrawal: "MANUAL",
    merchantType: 1,
    status: 1,
    localCurrency: "USD",
    emailPreferences: {
      "operation.charge_created": true,
      "operation.charge_expired": true,
      "operation.payment_status_updated": true,
      "operation.withdrawal_status_updated": true,
      "operation.invoice_created": true,
      "security.authentication_device_updated": true,
      "security.password_updated": true,
      "security.close_account": true,
      "security.remind_backup_codes_exceed_limit": true,
      "settings.support_email_updated": true,
      "settings.accept_crypto_list": true,
      "settings.flexible_payment_updated": true,
      "settings.auto_withdrawal_updated": true,
    },
    lastWithdrawal: [
      { "usdt-bsc": "2022-05-20T03:25:28.641Z" },
      { "usdc-bsc": "2022-05-20T03:25:28.641Z" },
      { "busd-bsc": "2022-05-20T03:25:28.641Z" },
      { "eth-bsc": "2022-05-20T03:25:28.641Z" },
      { "dai-bsc": "2022-05-20T03:25:28.641Z" },
      { "ada-bsc": "2022-05-20T03:25:28.641Z" },
      { "luna-bsc": "2022-05-20T03:25:28.641Z" },
      { "shib-bsc": "2022-05-20T03:25:28.641Z" },
      { "doge-bsc": "2022-05-20T03:25:28.641Z" },
      { "xrp-bsc": "2022-05-20T03:25:28.641Z" },
      { "bnb-bsc": "2022-05-20T03:25:28.641Z" },
    ],
    nextWithdrawal: [
      { "usdt-bsc": "2022-05-20T03:25:28.641Z" },
      { "usdc-bsc": "2022-05-20T03:25:28.641Z" },
      { "busd-bsc": "2022-05-20T03:25:28.641Z" },
      { "eth-bsc": "2022-05-20T03:25:28.641Z" },
      { "dai-bsc": "2022-05-20T03:25:28.641Z" },
      { "ada-bsc": "2022-05-20T03:25:28.641Z" },
      { "luna-bsc": "2022-05-20T03:25:28.641Z" },
      { "shib-bsc": "2022-05-20T03:25:28.641Z" },
      { "doge-bsc": "2022-05-20T03:25:28.641Z" },
      { "xrp-bsc": "2022-05-20T03:25:28.641Z" },
      { "bnb-bsc": "2022-05-20T03:25:28.641Z" },
    ],
    id: "62870a287ee202000702849c",
    email: "annd@sotanext.com",
    supportEmail: "annd@sotanext.com",
    wallets: [
      {
        bip44Path: "m/44'/60'/0'/0",
        currency: "BNB",
        isMainnet: false,
        provider: "https://speedy-nodes-nyc.moralis.io/d520aab28a624b9824dd80d7/bsc/testnet",
        wssProvider: "wss://speedy-nodes-nyc.moralis.io/d520aab28a624b9824dd80d7/bsc/testnet/ws",
        network: "binance-smart-chain-testnet",
        fpMasterContract: "0x463Af0c60a4bFc8cDb5EA52b9CB4A1102D315B53",
        transactionUrl: "https://testnet.bscscan.com/tx/",
        fizenReceiverWalletAddr: "0x12c8fEbF99C65B53158644f910B565063e967B62",
        contract: "0xfD17CE0497a48D51Ad776C3a5cf061D10f3074c6",
        address: "0xfDc1f44D85212f8a82A04e38e732c14d67a1781D",
      },
    ],
    cryptoCurrencySettings: [
      {
        name: "USDT",
        slug: "usdt-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x53653887c75d611A8EfbdA2c1FB97CFD17Bfff71",
        cmcId: 825,
        decimal: 18,
        type: ["STABLE_COIN", "POPULAR"],
        gasLimit: 70871,
        status: "INACTIVE",
        isEnabled: false,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        defaultStatus: "INACTIVE",
      },
      {
        name: "USDC",
        slug: "usdc-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x3a943EFa37979952DE37168aE7D9B2E8723D9316",
        cmcId: 3408,
        decimal: 18,
        type: ["STABLE_COIN", "POPULAR"],
        gasLimit: 70871,
        status: "INACTIVE",
        isEnabled: false,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        defaultStatus: "INACTIVE",
      },
      {
        name: "BUSD",
        slug: "busd-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x718f381412b0ec0B9a6f69a77E3c7128C75E77B5",
        cmcId: 4687,
        decimal: 18,
        type: ["STABLE_COIN", "POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        defaultStatus: "ACTIVE",
      },
      {
        name: "WETH",
        slug: "eth-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x17fA95F49e69F82766C7930D4035b2973fbe95b8",
        cmcId: 2396,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "INACTIVE",
        isEnabled: false,
        confirmedBalance: "0.000680184294016328",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0.000335016144814012",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        defaultStatus: "INACTIVE",
      },
      {
        name: "DAI",
        slug: "dai-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x460b248e24d2b14F59bf09a27fF73e4Bee7E140a",
        cmcId: 4943,
        decimal: 18,
        type: ["OTHERS"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        defaultStatus: "INACTIVE",
      },
      {
        name: "ADA",
        slug: "ada-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x78e67d427480D18890C807B3be219A8777900EcB",
        cmcId: 2010,
        decimal: 18,
        type: ["OTHERS"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        defaultStatus: "INACTIVE",
      },
      {
        name: "LUNA",
        slug: "luna-bsc",
        network: "binance-smart-chain-testnet",
        address: "0xc4E4FE5FcB38fE9D3BC327e384A57105955C9F9d",
        cmcId: 4172,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        defaultStatus: "INACTIVE",
      },
      {
        name: "SHIB",
        slug: "shib-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x00A7D83B69C8c9223438F0Aca93453c89e0E66Ac",
        cmcId: 5994,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        defaultStatus: "INACTIVE",
      },
      {
        name: "DOGE",
        slug: "doge-bsc",
        network: "binance-smart-chain-testnet",
        address: "0xD21399ad2bF05963D9a848697FdbF415c4D72923",
        cmcId: 74,
        decimal: 8,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        defaultStatus: "INACTIVE",
      },
      {
        name: "XRP",
        slug: "xrp-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x8802F1BA3748017B6a69A90bEd19c0542D0917bc",
        cmcId: 52,
        decimal: 18,
        type: ["OTHERS"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        defaultStatus: "INACTIVE",
      },
      {
        name: "BNB",
        slug: "bnb-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x0000000000000000000000000000000000000000",
        cmcId: 1839,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0.050014691962043142",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0.024634102011155575",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        defaultStatus: "INACTIVE",
      },
    ],
    provider: 1,
    fizenpayFeePerc: "33",
    createdAt: "2022-05-20T03:25:28.642Z",
    setUppedAt: "2022-05-24T03:33:42.362Z",
    customServiceFee: {
      status: "START_TIME_COMPLETED",
      serviceFee: "50",
      type: "DEFAULT",
      startTime: "2022-05-26T07:56:56.476Z",
      endTime: "2022-05-26T07:56:56.476Z",
    },
    updatedAt: "2022-05-26T02:24:30.870Z",
    flexiblePaymentSettings: {
      type: "ABSOLUTE",
      underPaymentThresholdValue: "0.1",
      underPaymentCurrency: "USD",
      overPaymentThresholdValue: "5",
      overPaymentCurrency: "USD",
    },
    security: { is2faEnabled: true, isEmailVerifyEnabled: false, emailCodeExp: 0 },
  },
  {
    currentStep: "WALLET_SETUP_COMPLETED",
    approvedStatus: "APPROVED",
    autoWithdrawal: "MANUAL",
    merchantType: 1,
    status: 1,
    localCurrency: "USD",
    emailPreferences: {
      "operation.charge_created": true,
      "operation.charge_expired": true,
      "operation.payment_status_updated": true,
      "operation.withdrawal_status_updated": true,
      "operation.invoice_created": true,
      "security.authentication_device_updated": true,
      "security.password_updated": true,
      "security.close_account": true,
      "security.remind_backup_codes_exceed_limit": true,
      "settings.support_email_updated": true,
      "settings.accept_crypto_list": true,
      "settings.flexible_payment_updated": true,
      "settings.auto_withdrawal_updated": true,
    },
    lastWithdrawal: [
      { "usdt-bsc": "2022-05-24T11:36:18.456Z" },
      { "usdc-bsc": "2022-05-24T11:36:18.456Z" },
      { "busd-bsc": "2022-05-24T11:36:18.456Z" },
      { "eth-bsc": "2022-05-24T11:36:18.456Z" },
      { "dai-bsc": "2022-05-24T11:36:18.456Z" },
      { "ada-bsc": "2022-05-24T11:36:18.456Z" },
      { "luna-bsc": "2022-05-24T11:36:18.456Z" },
      { "shib-bsc": "2022-05-24T11:36:18.456Z" },
      { "doge-bsc": "2022-05-24T11:36:18.456Z" },
      { "xrp-bsc": "2022-05-24T11:36:18.456Z" },
      { "bnb-bsc": "2022-05-24T11:36:18.456Z" },
    ],
    nextWithdrawal: [
      { "usdt-bsc": "2022-05-19T08:46:21.159Z" },
      { "usdc-bsc": "2022-05-19T08:46:21.159Z" },
      { "busd-bsc": "2022-05-19T08:46:21.159Z" },
      { "eth-bsc": "2022-05-19T08:46:21.159Z" },
      { "dai-bsc": "2022-05-19T08:46:21.159Z" },
      { "ada-bsc": "2022-05-20T09:59:10.073Z" },
      { "luna-bsc": "2022-05-19T08:46:21.159Z" },
      { "shib-bsc": "2022-05-19T08:46:21.159Z" },
      { "doge-bsc": "2022-05-19T08:46:21.159Z" },
      { "xrp-bsc": "2022-05-19T08:46:21.159Z" },
      { "bnb-bsc": "2022-05-19T08:46:21.159Z" },
    ],
    id: "628603dd75ebdf00083568dc",
    rejectReason: null,
    name: null,
    email: "ngale25021997@gmail.com",
    supportEmail: "ngale25021997@gmail.com",
    wallets: [
      {
        bip44Path: "m/44'/60'/0'/0",
        currency: "BNB",
        isMainnet: false,
        provider: "https://speedy-nodes-nyc.moralis.io/d520aab28a624b9824dd80d7/bsc/testnet",
        wssProvider: "wss://speedy-nodes-nyc.moralis.io/d520aab28a624b9824dd80d7/bsc/testnet/ws",
        network: "binance-smart-chain-testnet",
        fpMasterContract: "0x463Af0c60a4bFc8cDb5EA52b9CB4A1102D315B53",
        transactionUrl: "https://testnet.bscscan.com/tx/",
        fizenReceiverWalletAddr: "0x12c8fEbF99C65B53158644f910B565063e967B62",
        contract: "0x237B15c5ddA7809fC1Cb0d1a8bD31F5eA232Cc24",
        address: "0xE89A017cEd5F25b20DBbceEDB25A5432CAf26aB3",
      },
    ],
    cryptoCurrencySettings: [
      {
        name: "USDT",
        slug: "usdt-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x53653887c75d611A8EfbdA2c1FB97CFD17Bfff71",
        cmcId: 825,
        decimal: 18,
        type: ["STABLE_COIN", "POPULAR"],
        gasLimit: 70871,
        status: "INACTIVE",
        isEnabled: false,
        confirmedBalance: "0",
        unconfirmedBalance: "1.34",
        fizenFeeBalance: "6.454342330256117581",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        withdrawalHistory: {
          _bsontype: "ObjectID",
          id: { type: "Buffer", data: [98, 135, 99, 218, 4, 30, 116, 0, 8, 23, 185, 17] },
        },
        defaultStatus: "INACTIVE",
      },
      {
        name: "USDC",
        slug: "usdc-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x3a943EFa37979952DE37168aE7D9B2E8723D9316",
        cmcId: 3408,
        decimal: 18,
        type: ["STABLE_COIN", "POPULAR"],
        gasLimit: 70871,
        status: "INACTIVE",
        isEnabled: false,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "3.517974795256955544",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        withdrawalHistory: {
          _bsontype: "ObjectID",
          id: { type: "Buffer", data: [98, 135, 95, 152, 4, 30, 116, 0, 8, 23, 184, 186] },
        },
        defaultStatus: "INACTIVE",
      },
      {
        name: "BUSD",
        slug: "busd-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x718f381412b0ec0B9a6f69a77E3c7128C75E77B5",
        cmcId: 4687,
        decimal: 18,
        type: ["STABLE_COIN", "POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "17.531808001137318277",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        withdrawalHistory: {
          _bsontype: "ObjectID",
          id: { type: "Buffer", data: [98, 135, 101, 146, 4, 30, 116, 0, 8, 23, 185, 22] },
        },
        defaultStatus: "ACTIVE",
      },
      {
        name: "WETH",
        slug: "eth-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x17fA95F49e69F82766C7930D4035b2973fbe95b8",
        cmcId: 2396,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "INACTIVE",
        isEnabled: false,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        withdrawalHistory: "628cacc8c5bfc10009ce96f8",
        defaultStatus: "INACTIVE",
      },
      {
        name: "DAI",
        slug: "dai-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x460b248e24d2b14F59bf09a27fF73e4Bee7E140a",
        cmcId: 4943,
        decimal: 18,
        type: ["OTHERS"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "1.557666163299201753",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        withdrawalHistory: {
          _bsontype: "ObjectID",
          id: { type: "Buffer", data: [98, 135, 109, 218, 4, 30, 116, 0, 8, 23, 185, 57] },
        },
        defaultStatus: "INACTIVE",
      },
      {
        name: "ADA",
        slug: "ada-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x78e67d427480D18890C807B3be219A8777900EcB",
        cmcId: 2010,
        decimal: 18,
        type: ["OTHERS"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "25.723943924426452104",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        withdrawalHistory: {
          _bsontype: "ObjectID",
          id: { type: "Buffer", data: [98, 135, 98, 174, 4, 30, 116, 0, 8, 23, 185, 4] },
        },
        defaultStatus: "INACTIVE",
      },
      {
        name: "LUNA",
        slug: "luna-bsc",
        network: "binance-smart-chain-testnet",
        address: "0xc4E4FE5FcB38fE9D3BC327e384A57105955C9F9d",
        cmcId: 4172,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        defaultStatus: "INACTIVE",
      },
      {
        name: "SHIB",
        slug: "shib-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x00A7D83B69C8c9223438F0Aca93453c89e0E66Ac",
        cmcId: 5994,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        defaultStatus: "INACTIVE",
      },
      {
        name: "DOGE",
        slug: "doge-bsc",
        network: "binance-smart-chain-testnet",
        address: "0xD21399ad2bF05963D9a848697FdbF415c4D72923",
        cmcId: 74,
        decimal: 8,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "40.58205212",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        withdrawalHistory: "628b523823ed950008b950cf",
        defaultStatus: "INACTIVE",
      },
      {
        name: "XRP",
        slug: "xrp-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x8802F1BA3748017B6a69A90bEd19c0542D0917bc",
        cmcId: 52,
        decimal: 18,
        type: ["OTHERS"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        defaultStatus: "INACTIVE",
      },
      {
        name: "BNB",
        slug: "bnb-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x0000000000000000000000000000000000000000",
        cmcId: 1839,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0.000824035769577745",
        unconfirmedBalance: "0.000715921717552961",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        withdrawalHistory: {
          _bsontype: "ObjectID",
          id: { type: "Buffer", data: [98, 135, 103, 54, 4, 30, 116, 0, 8, 23, 185, 49] },
        },
        defaultStatus: "INACTIVE",
      },
    ],
    provider: 1,
    fizenpayFeePerc: "1",
    createdAt: "2022-05-19T08:46:21.160Z",
    setUppedAt: "2022-05-19T08:48:31.091Z",
    customServiceFee: {
      status: "START_TIME_COMPLETED",
      serviceFee: "1",
      type: "CUSTOMIZE",
      startTime: "2022-05-24T10:47:00.000Z",
      endTime: "2022-05-24T10:46:50.067Z",
    },
    updatedAt: "2022-05-26T02:27:10.190Z",
    flexiblePaymentSettings: {
      type: "ABSOLUTE",
      underPaymentThresholdValue: "50.59444",
      underPaymentCurrency: "USD",
      overPaymentThresholdValue: "200000",
      overPaymentCurrency: "USD",
    },
    security: { is2faEnabled: true, isEmailVerifyEnabled: false, emailCodeExp: 0 },
  },
  {
    currentStep: "EMAIL_VERIFIED",
    approvedStatus: "APPROVED",
    autoWithdrawal: "MANUAL",
    merchantType: 1,
    status: 1,
    localCurrency: "USD",
    emailPreferences: {
      "operation.charge_created": true,
      "operation.charge_expired": true,
      "operation.payment_status_updated": true,
      "operation.withdrawal_status_updated": true,
      "operation.invoice_created": true,
      "security.authentication_device_updated": true,
      "security.password_updated": true,
      "security.close_account": true,
      "security.remind_backup_codes_exceed_limit": true,
      "settings.support_email_updated": true,
      "settings.accept_crypto_list": true,
      "settings.flexible_payment_updated": true,
      "settings.auto_withdrawal_updated": true,
    },
    lastWithdrawal: [
      { "usdt-bsc": "2022-05-19T08:38:58.779Z" },
      { "usdc-bsc": "2022-05-19T08:38:58.779Z" },
      { "busd-bsc": "2022-05-19T08:38:58.779Z" },
      { "eth-bsc": "2022-05-19T08:38:58.779Z" },
      { "dai-bsc": "2022-05-19T08:38:58.779Z" },
      { "ada-bsc": "2022-05-19T08:38:58.779Z" },
      { "luna-bsc": "2022-05-19T08:38:58.779Z" },
      { "shib-bsc": "2022-05-19T08:38:58.779Z" },
      { "doge-bsc": "2022-05-19T08:38:58.779Z" },
      { "xrp-bsc": "2022-05-19T08:38:58.779Z" },
      { "bnb-bsc": "2022-05-19T08:38:58.779Z" },
    ],
    nextWithdrawal: [
      { "usdt-bsc": "2022-05-19T08:38:58.779Z" },
      { "usdc-bsc": "2022-05-19T08:38:58.779Z" },
      { "busd-bsc": "2022-05-19T08:38:58.779Z" },
      { "eth-bsc": "2022-05-19T08:38:58.779Z" },
      { "dai-bsc": "2022-05-19T08:38:58.779Z" },
      { "ada-bsc": "2022-05-19T08:38:58.779Z" },
      { "luna-bsc": "2022-05-19T08:38:58.779Z" },
      { "shib-bsc": "2022-05-19T08:38:58.779Z" },
      { "doge-bsc": "2022-05-19T08:38:58.779Z" },
      { "xrp-bsc": "2022-05-19T08:38:58.779Z" },
      { "bnb-bsc": "2022-05-19T08:38:58.779Z" },
    ],
    id: "6286022275ebdf00083568da",
    email: "huuhoa14399+1@gmail.com",
    supportEmail: "huuhoa14399+1@gmail.com",
    cryptoCurrencySettings: [
      {
        name: "USDT",
        slug: "usdt-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x53653887c75d611A8EfbdA2c1FB97CFD17Bfff71",
        cmcId: 825,
        decimal: 18,
        type: ["STABLE_COIN", "POPULAR"],
        gasLimit: 70871,
        status: "INACTIVE",
        isEnabled: false,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        defaultStatus: "INACTIVE",
      },
      {
        name: "USDC",
        slug: "usdc-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x3a943EFa37979952DE37168aE7D9B2E8723D9316",
        cmcId: 3408,
        decimal: 18,
        type: ["STABLE_COIN", "POPULAR"],
        gasLimit: 70871,
        status: "INACTIVE",
        isEnabled: false,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        defaultStatus: "INACTIVE",
      },
      {
        name: "BUSD",
        slug: "busd-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x718f381412b0ec0B9a6f69a77E3c7128C75E77B5",
        cmcId: 4687,
        decimal: 18,
        type: ["STABLE_COIN", "POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        defaultStatus: "ACTIVE",
      },
      {
        name: "WETH",
        slug: "eth-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x17fA95F49e69F82766C7930D4035b2973fbe95b8",
        cmcId: 2396,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "INACTIVE",
        isEnabled: false,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        defaultStatus: "INACTIVE",
      },
      {
        name: "DAI",
        slug: "dai-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x460b248e24d2b14F59bf09a27fF73e4Bee7E140a",
        cmcId: 4943,
        decimal: 18,
        type: ["OTHERS"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        defaultStatus: "INACTIVE",
      },
      {
        name: "ADA",
        slug: "ada-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x78e67d427480D18890C807B3be219A8777900EcB",
        cmcId: 2010,
        decimal: 18,
        type: ["OTHERS"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        defaultStatus: "INACTIVE",
      },
      {
        name: "LUNA",
        slug: "luna-bsc",
        network: "binance-smart-chain-testnet",
        address: "0xc4E4FE5FcB38fE9D3BC327e384A57105955C9F9d",
        cmcId: 4172,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        defaultStatus: "INACTIVE",
      },
      {
        name: "SHIB",
        slug: "shib-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x00A7D83B69C8c9223438F0Aca93453c89e0E66Ac",
        cmcId: 5994,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        defaultStatus: "INACTIVE",
      },
      {
        name: "DOGE",
        slug: "doge-bsc",
        network: "binance-smart-chain-testnet",
        address: "0xD21399ad2bF05963D9a848697FdbF415c4D72923",
        cmcId: 74,
        decimal: 8,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        defaultStatus: "INACTIVE",
      },
      {
        name: "XRP",
        slug: "xrp-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x8802F1BA3748017B6a69A90bEd19c0542D0917bc",
        cmcId: 52,
        decimal: 18,
        type: ["OTHERS"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        defaultStatus: "INACTIVE",
      },
      {
        name: "BNB",
        slug: "bnb-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x0000000000000000000000000000000000000000",
        cmcId: 1839,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        defaultStatus: "INACTIVE",
      },
    ],
    provider: 1,
    createdAt: "2022-05-19T08:38:58.783Z",
    updatedAt: "2022-05-26T02:24:30.820Z",
    flexiblePaymentSettings: {
      type: "ABSOLUTE",
      underPaymentThresholdValue: "0.1",
      underPaymentCurrency: "USD",
      overPaymentThresholdValue: "5",
      overPaymentCurrency: "USD",
    },
    security: { is2faEnabled: false, isEmailVerifyEnabled: false, emailCodeExp: 0 },
  },
  {
    currentStep: "EMAIL_VERIFIED",
    approvedStatus: "APPROVED",
    autoWithdrawal: "MANUAL",
    merchantType: 1,
    status: 1,
    localCurrency: "USD",
    emailPreferences: {
      "operation.charge_created": true,
      "operation.charge_expired": true,
      "operation.payment_status_updated": true,
      "operation.withdrawal_status_updated": true,
      "operation.invoice_created": true,
      "security.authentication_device_updated": true,
      "security.password_updated": true,
      "security.close_account": true,
      "security.remind_backup_codes_exceed_limit": true,
      "settings.support_email_updated": true,
      "settings.accept_crypto_list": true,
      "settings.flexible_payment_updated": true,
      "settings.auto_withdrawal_updated": true,
    },
    lastWithdrawal: [
      { "usdt-bsc": "2022-05-19T08:26:58.038Z" },
      { "usdc-bsc": "2022-05-19T08:26:58.038Z" },
      { "busd-bsc": "2022-05-19T08:26:58.038Z" },
      { "eth-bsc": "2022-05-19T08:26:58.038Z" },
      { "dai-bsc": "2022-05-19T08:26:58.038Z" },
      { "ada-bsc": "2022-05-19T08:26:58.038Z" },
      { "luna-bsc": "2022-05-19T08:26:58.038Z" },
      { "shib-bsc": "2022-05-19T08:26:58.038Z" },
      { "doge-bsc": "2022-05-19T08:26:58.038Z" },
      { "xrp-bsc": "2022-05-19T08:26:58.038Z" },
      { "bnb-bsc": "2022-05-19T08:26:58.038Z" },
    ],
    nextWithdrawal: [
      { "usdt-bsc": "2022-05-19T08:26:58.038Z" },
      { "usdc-bsc": "2022-05-19T08:26:58.038Z" },
      { "busd-bsc": "2022-05-19T08:26:58.038Z" },
      { "eth-bsc": "2022-05-19T08:26:58.038Z" },
      { "dai-bsc": "2022-05-19T08:26:58.038Z" },
      { "ada-bsc": "2022-05-19T08:26:58.038Z" },
      { "luna-bsc": "2022-05-19T08:26:58.038Z" },
      { "shib-bsc": "2022-05-19T08:26:58.038Z" },
      { "doge-bsc": "2022-05-19T08:26:58.038Z" },
      { "xrp-bsc": "2022-05-19T08:26:58.038Z" },
      { "bnb-bsc": "2022-05-19T08:26:58.038Z" },
    ],
    id: "6285ff5275ebdf00083568d8",
    email: "huuhoa14399@gmail.com",
    supportEmail: "huuhoa14399@gmail.com",
    cryptoCurrencySettings: [
      {
        name: "USDT",
        slug: "usdt-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x53653887c75d611A8EfbdA2c1FB97CFD17Bfff71",
        cmcId: 825,
        decimal: 18,
        type: ["STABLE_COIN", "POPULAR"],
        gasLimit: 70871,
        status: "INACTIVE",
        isEnabled: false,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        defaultStatus: "INACTIVE",
      },
      {
        name: "USDC",
        slug: "usdc-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x3a943EFa37979952DE37168aE7D9B2E8723D9316",
        cmcId: 3408,
        decimal: 18,
        type: ["STABLE_COIN", "POPULAR"],
        gasLimit: 70871,
        status: "INACTIVE",
        isEnabled: false,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        defaultStatus: "INACTIVE",
      },
      {
        name: "BUSD",
        slug: "busd-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x718f381412b0ec0B9a6f69a77E3c7128C75E77B5",
        cmcId: 4687,
        decimal: 18,
        type: ["STABLE_COIN", "POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        defaultStatus: "ACTIVE",
      },
      {
        name: "WETH",
        slug: "eth-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x17fA95F49e69F82766C7930D4035b2973fbe95b8",
        cmcId: 2396,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "INACTIVE",
        isEnabled: false,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        defaultStatus: "INACTIVE",
      },
      {
        name: "DAI",
        slug: "dai-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x460b248e24d2b14F59bf09a27fF73e4Bee7E140a",
        cmcId: 4943,
        decimal: 18,
        type: ["OTHERS"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        defaultStatus: "INACTIVE",
      },
      {
        name: "ADA",
        slug: "ada-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x78e67d427480D18890C807B3be219A8777900EcB",
        cmcId: 2010,
        decimal: 18,
        type: ["OTHERS"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        defaultStatus: "INACTIVE",
      },
      {
        name: "LUNA",
        slug: "luna-bsc",
        network: "binance-smart-chain-testnet",
        address: "0xc4E4FE5FcB38fE9D3BC327e384A57105955C9F9d",
        cmcId: 4172,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        defaultStatus: "INACTIVE",
      },
      {
        name: "SHIB",
        slug: "shib-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x00A7D83B69C8c9223438F0Aca93453c89e0E66Ac",
        cmcId: 5994,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        defaultStatus: "INACTIVE",
      },
      {
        name: "DOGE",
        slug: "doge-bsc",
        network: "binance-smart-chain-testnet",
        address: "0xD21399ad2bF05963D9a848697FdbF415c4D72923",
        cmcId: 74,
        decimal: 8,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        defaultStatus: "INACTIVE",
      },
      {
        name: "XRP",
        slug: "xrp-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x8802F1BA3748017B6a69A90bEd19c0542D0917bc",
        cmcId: 52,
        decimal: 18,
        type: ["OTHERS"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        defaultStatus: "INACTIVE",
      },
      {
        name: "BNB",
        slug: "bnb-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x0000000000000000000000000000000000000000",
        cmcId: 1839,
        decimal: 18,
        type: ["POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
        defaultStatus: "INACTIVE",
      },
    ],
    provider: 1,
    createdAt: "2022-05-19T08:26:58.042Z",
    updatedAt: "2022-05-26T02:24:30.815Z",
    flexiblePaymentSettings: {
      type: "ABSOLUTE",
      underPaymentThresholdValue: "0.1",
      underPaymentCurrency: "USD",
      overPaymentThresholdValue: "5",
      overPaymentCurrency: "USD",
    },
    security: { is2faEnabled: false, isEmailVerifyEnabled: false, emailCodeExp: 0 },
  },
  {
    currentStep: "WALLET_SETUP_COMPLETED",
    approvedStatus: "APPROVED",
    autoWithdrawal: "MANUAL",
    merchantType: 1,
    status: 1,
    localCurrency: "USD",
    emailPreferences: {
      "operation-charge_created": true,
      "operation-charge_expired": true,
      "operation-payment_status_updated": true,
      "operation-withdrawal_status_updated": true,
      "operation-invoice_created": true,
      "security-authentication_device_updated": true,
      "security-password_updated": true,
      "security-close_account": true,
      "security-remind_backup_codes_exceed_limit": true,
      "settings-support_email_updated": true,
      "settings-accept_crypto_list": true,
      "settings-flexible_payment_updated": true,
      "settings-auto_withdrawal_updated": true,
    },
    lastWithdrawal: [
      { "zsd-bsc": "2022-05-26T09:00:22.060Z" },
      { "busd-bsc": "2022-05-26T09:00:22.060Z" },
    ],
    nextWithdrawal: [
      { "zsd-bsc": "2022-05-26T09:00:22.060Z" },
      { "busd-bsc": "2022-05-26T09:00:22.060Z" },
    ],
    id: "628f41a64c14e30008d86a5f",
    email: "tuandt@sotanext.com",
    supportEmail: "tuandt@sotanext.com",
    wallets: [
      {
        bip44Path: "m/44'/60'/0'/0",
        currency: "BNB",
        isMainnet: false,
        provider: "https://speedy-nodes-nyc.moralis.io/d520aab28a624b9824dd80d7/bsc/testnet",
        wssProvider: "wss://speedy-nodes-nyc.moralis.io/d520aab28a624b9824dd80d7/bsc/testnet/ws",
        network: "binance-smart-chain-testnet",
        fpMasterContract: "0x463Af0c60a4bFc8cDb5EA52b9CB4A1102D315B53",
        transactionUrl: "https://testnet.bscscan.com/tx/",
        fizenReceiverWalletAddr: "0x12c8fEbF99C65B53158644f910B565063e967B62",
        contract: "0x0b69532B28741e3440319609a4B600B876003AA4",
        address: "0x8A77E3727893f4081DF75f5ad41Df341EB38Fe9c",
      },
    ],
    cryptoCurrencySettings: [
      {
        name: "ZSD",
        slug: "zsd-bsc",
        network: "binance-smart-chain-testnet",
        address: "0xB9809E3955fA034bF3F9aE53e0Ab471E03D7c657",
        cmcId: 8772,
        decimal: 18,
        type: ["STABLE_COIN"],
        gasLimit: 70871,
        status: "ACTIVE",
        defaultStatus: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "BUSD",
        slug: "busd-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x718f381412b0ec0B9a6f69a77E3c7128C75E77B5",
        cmcId: 4687,
        decimal: 18,
        type: ["STABLE_COIN", "POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        defaultStatus: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
    ],
    provider: 1,
    requestForgotPasswordAt: "2022-05-26T09:00:22.063Z",
    fizenpayFeePerc: "33",
    setUppedAt: "2022-05-26T09:02:50.179Z",
    customServiceFee: {
      status: "INITIAL",
      serviceFee: "0",
      type: "DEFAULT",
      startTime: "2022-05-26T09:02:50.179Z",
      endTime: "2022-05-26T09:02:50.179Z",
    },
    updatedAt: "2022-05-26T09:00:22.063Z",
    flexiblePaymentSettings: {
      type: "ABSOLUTE",
      underPaymentThresholdValue: "0.1",
      underPaymentCurrency: "USD",
      overPaymentThresholdValue: "5",
      overPaymentCurrency: "USD",
    },
    security: { is2faEnabled: true, isEmailVerifyEnabled: false, emailCodeExp: 0 },
  },
  {
    currentStep: "EMAIL_VERIFIED",
    approvedStatus: "APPROVED",
    autoWithdrawal: "MANUAL",
    merchantType: 1,
    status: 1,
    localCurrency: "USD",
    emailPreferences: {
      "operation-charge_created": true,
      "operation-charge_expired": true,
      "operation-payment_status_updated": true,
      "operation-withdrawal_status_updated": true,
      "operation-invoice_created": true,
      "security-authentication_device_updated": true,
      "security-password_updated": true,
      "security-close_account": true,
      "security-remind_backup_codes_exceed_limit": true,
      "settings-support_email_updated": true,
      "settings-accept_crypto_list": true,
      "settings-flexible_payment_updated": true,
      "settings-auto_withdrawal_updated": true,
    },
    lastWithdrawal: [
      { "zsd-bsc": "2022-05-27T01:55:42.353Z" },
      { "busd-bsc": "2022-05-27T01:55:42.353Z" },
    ],
    nextWithdrawal: [
      { "zsd-bsc": "2022-05-27T01:55:42.353Z" },
      { "busd-bsc": "2022-05-27T01:55:42.353Z" },
    ],
    id: "62902f9e4c14e30008d86a64",
    email: "hieunm2.86@gmail.com",
    supportEmail: "hieunm2.86@gmail.com",
    cryptoCurrencySettings: [
      {
        name: "ZSD",
        slug: "zsd-bsc",
        network: "binance-smart-chain-testnet",
        address: "0xB9809E3955fA034bF3F9aE53e0Ab471E03D7c657",
        cmcId: 8772,
        decimal: 18,
        type: ["STABLE_COIN"],
        gasLimit: 70871,
        status: "ACTIVE",
        defaultStatus: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "BUSD",
        slug: "busd-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x718f381412b0ec0B9a6f69a77E3c7128C75E77B5",
        cmcId: 4687,
        decimal: 18,
        type: ["STABLE_COIN", "POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        defaultStatus: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
    ],
    provider: 1,
    requestForgotPasswordAt: "2022-05-27T01:55:42.359Z",
    updatedAt: "2022-05-27T01:55:42.359Z",
    flexiblePaymentSettings: {
      type: "ABSOLUTE",
      underPaymentThresholdValue: "0.1",
      underPaymentCurrency: "USD",
      overPaymentThresholdValue: "5",
      overPaymentCurrency: "USD",
    },
    security: { is2faEnabled: false, isEmailVerifyEnabled: false, emailCodeExp: 0 },
  },
  {
    currentStep: "WALLET_SETUP_COMPLETED",
    approvedStatus: "APPROVED",
    autoWithdrawal: "MANUAL",
    merchantType: 1,
    status: 1,
    localCurrency: "USD",
    emailPreferences: {
      "operation-charge_created": true,
      "operation-charge_expired": true,
      "operation-payment_status_updated": true,
      "operation-withdrawal_status_updated": true,
      "operation-invoice_created": true,
      "security-authentication_device_updated": true,
      "security-password_updated": true,
      "security-close_account": true,
      "security-remind_backup_codes_exceed_limit": true,
      "settings-support_email_updated": true,
      "settings-accept_crypto_list": true,
      "settings-flexible_payment_updated": true,
      "settings-auto_withdrawal_updated": true,
    },
    lastWithdrawal: [
      { "zsd-bsc": "2022-05-27T08:21:41.885Z" },
      { "busd-bsc": "2022-05-27T08:21:41.885Z" },
    ],
    nextWithdrawal: [
      { "zsd-bsc": "2022-05-27T08:21:41.885Z" },
      { "busd-bsc": "2022-05-27T08:21:41.885Z" },
    ],
    id: "62908a155d6a600008416034",
    email: "minhbn@sotanext.com",
    supportEmail: "minhbn@sotanext.com",
    wallets: [
      {
        bip44Path: "m/44'/60'/0'/0",
        currency: "BNB",
        isMainnet: false,
        provider: "https://speedy-nodes-nyc.moralis.io/d520aab28a624b9824dd80d7/bsc/testnet",
        wssProvider: "wss://speedy-nodes-nyc.moralis.io/d520aab28a624b9824dd80d7/bsc/testnet/ws",
        network: "binance-smart-chain-testnet",
        fpMasterContract: "0x463Af0c60a4bFc8cDb5EA52b9CB4A1102D315B53",
        transactionUrl: "https://testnet.bscscan.com/tx/",
        fizenReceiverWalletAddr: "0x12c8fEbF99C65B53158644f910B565063e967B62",
        contract: "0x83BFa86855aF1acf0c5851A38e3Eea2aaFb56293",
        address: "0xeA0CE588A93Ba88511f4D12670eCe4C4dB512da6",
      },
    ],
    cryptoCurrencySettings: [
      {
        name: "ZSD",
        slug: "zsd-bsc",
        network: "binance-smart-chain-testnet",
        address: "0xB9809E3955fA034bF3F9aE53e0Ab471E03D7c657",
        cmcId: 8772,
        decimal: 18,
        type: ["STABLE_COIN"],
        gasLimit: 70871,
        status: "ACTIVE",
        defaultStatus: "ACTIVE",
        isEnabled: false,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "BUSD",
        slug: "busd-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x718f381412b0ec0B9a6f69a77E3c7128C75E77B5",
        cmcId: 4687,
        decimal: 18,
        type: ["STABLE_COIN", "POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        defaultStatus: "ACTIVE",
        isEnabled: false,
        confirmedBalance: "0.669404660466745049",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0.329706773065710247",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
    ],
    provider: 1,
    requestForgotPasswordAt: "2022-05-27T08:21:41.890Z",
    fizenpayFeePerc: "33",
    setUppedAt: "2022-05-27T08:31:59.442Z",
    customServiceFee: {
      status: "INITIAL",
      serviceFee: "0",
      type: "DEFAULT",
      startTime: "2022-05-27T08:21:41.886Z",
      endTime: "2022-05-27T08:21:41.886Z",
    },
    updatedAt: "2022-05-27T08:21:41.890Z",
    flexiblePaymentSettings: {
      type: "ABSOLUTE",
      underPaymentThresholdValue: "0.1",
      underPaymentCurrency: "USD",
      overPaymentThresholdValue: "5",
      overPaymentCurrency: "USD",
    },
    security: { is2faEnabled: true, isEmailVerifyEnabled: false, emailCodeExp: 0 },
  },
  {
    currentStep: "EMAIL_VERIFIED",
    approvedStatus: "PENDING",
    autoWithdrawal: "MANUAL",
    merchantType: 1,
    status: 1,
    localCurrency: "USD",
    emailPreferences: {
      "operation-charge_created": true,
      "operation-charge_expired": true,
      "operation-payment_status_updated": true,
      "operation-withdrawal_status_updated": true,
      "operation-invoice_created": true,
      "security-authentication_device_updated": true,
      "security-password_updated": true,
      "security-close_account": true,
      "security-remind_backup_codes_exceed_limit": true,
      "settings-support_email_updated": true,
      "settings-accept_crypto_list": true,
      "settings-flexible_payment_updated": true,
      "settings-auto_withdrawal_updated": true,
    },
    lastWithdrawal: [
      { "zsd-bsc": "2022-05-27T09:02:46.442Z" },
      { "busd-bsc": "2022-05-27T09:02:46.443Z" },
    ],
    nextWithdrawal: [
      { "zsd-bsc": "2022-05-27T09:02:46.442Z" },
      { "busd-bsc": "2022-05-27T09:02:46.443Z" },
    ],
    id: "629093b65d6a600008416039",
    email: "hieunm286@gmail.com",
    supportEmail: "hieunm286@gmail.com",
    cryptoCurrencySettings: [
      {
        name: "ZSD",
        slug: "zsd-bsc",
        network: "binance-smart-chain-testnet",
        address: "0xB9809E3955fA034bF3F9aE53e0Ab471E03D7c657",
        cmcId: 8772,
        decimal: 18,
        type: ["STABLE_COIN"],
        gasLimit: 70871,
        status: "ACTIVE",
        defaultStatus: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
      {
        name: "BUSD",
        slug: "busd-bsc",
        network: "binance-smart-chain-testnet",
        address: "0x718f381412b0ec0B9a6f69a77E3c7128C75E77B5",
        cmcId: 4687,
        decimal: 18,
        type: ["STABLE_COIN", "POPULAR"],
        gasLimit: 70871,
        status: "ACTIVE",
        defaultStatus: "ACTIVE",
        isEnabled: true,
        confirmedBalance: "0",
        unconfirmedBalance: "0",
        fizenFeeBalance: "0",
        withdrawTokenStatus: "INACTIVE",
        autoWithdrawalStatus: "INACTIVE",
      },
    ],
    provider: 1,
    requestForgotPasswordAt: "2022-05-27T09:02:46.447Z",
    fizenpayFeePerc: "33",
    customServiceFee: {
      status: "INITIAL",
      serviceFee: "0",
      type: "DEFAULT",
      startTime: "2022-05-27T09:02:46.444Z",
      endTime: "2022-05-27T09:02:46.444Z",
    },
    updatedAt: "2022-05-27T09:02:46.447Z",
    flexiblePaymentSettings: {
      type: "ABSOLUTE",
      underPaymentThresholdValue: "0.1",
      underPaymentCurrency: "USD",
      overPaymentThresholdValue: "5",
      overPaymentCurrency: "USD",
    },
    security: { is2faEnabled: false, isEmailVerifyEnabled: false, emailCodeExp: 0 },
  },
];

export const onGetAllRegister = () => {
  axiosMockAdapterInstance.onGet("/merchants/registration").reply(() => {
    return [200, getResponseData(regisData)];
  });
};
